import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { IRegionItem } from '../interfaces/IRegion';
import { ISupportContactExtended, ISupportContactItem } from '../interfaces/ISupportContact';
import { TENANT } from '../Tenant.enum';

@Injectable({ providedIn: 'root' })
export class SupportContactsService {
  private readonly http = inject(HttpClient);

  private allTitles?: ISupportContactItem[];

  public getAllSupportContacts(company: string): Observable<ISupportContactItem[]> {
    if (this.allTitles) {
      return of(this.allTitles);
    }

    const URL = `${environment.api.backend}support-contacts?tenant=${company}`;
    return this.http.get<ISupportContactItem[]>(URL).pipe(tap(titles => (this.allTitles = titles)));
  }

  public getAllRegions(): Observable<IRegionItem[]> {
    const URL = `${environment.api.backend}regions`;
    return this.http.get<IRegionItem[]>(URL);
  }

  public getAllForCMS(): Observable<ISupportContactExtended[]> {
    const URL = `${environment.api.backend}support-contacts/cms`;
    return this.http.get<ISupportContactExtended[]>(URL);
  }

  public saveNewSupportContact(tenant: TENANT, item: ISupportContactItem): Observable<any> {
    const URL = `${environment.api.backend}support-contacts?tenant=${tenant}&id=${item.id}&language=en`;
    return this.http.post(URL, item);
  }

  public saveNewRegion(item: IRegionItem): Observable<any> {
    const URL = `${environment.api.backend}regions?tenant=siemens&region=${item.region}&id=${item.id}&language=en`;
    return this.http.post(URL, item);
  }

  public updateSupportContact(tenant: TENANT, item: ISupportContactItem): Observable<any> {
    const URL = `${environment.api.backend}support-contacts?tenant=${tenant}&id=${item.id}&language=en`;
    return this.http.put(URL, item);
  }

  public deleteSupportContact(tenant: TENANT, id: string): Observable<void> {
    const URL = `${environment.api.backend}support-contacts?tenant=${tenant}&id=${id}`;
    return this.http.delete<void>(URL);
  }
}
